<template>
  <div>

    <div class="corpo-menu-event marigne-lat">

      <div class="row">
        <div class="col s12 m10 l4 xl4">
          <h1 class="style">{{ traduzione('guest.list.fields.selection') }}</h1>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m12 l6 xl6">
          <p>{{ traduzione('limit.text.filed.custom') }}</p>
          <p>{{ traduzione('not.include.name.surname') }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m12 l6 xl6">
          <form>
            <div>
              <div class="input-field">
                <i class="material-icons prefix">format_color_text</i>

                <input
                  type="text"
                  v-model="etichettaString"
                  class="validate required"
                  id="etichetta"
                  autocomplete="on"
                  :disabled="items.length >= 6"
                  @input="clearErrors"
                /> <label for="etichetta">{{ traduzione('label.scelta.etichetta')
                  }}</label>
            <span id="btadd" class="add-toggle">
              <i class="small material-icons prefix"
                :class="items.length >= 6 ? 'grey-text' : 'onmouseover'"
                @click="items.length < 6 ? addItem() : null">
                library_add
              </i>
            </span>

              </div>
              <span id="error-message-campo-etichetta" class="error-message-style error-message-style-dim nodipslay">
                {{ traduzione('errore.etichetta.campi.pax') }}
              </span>
              <span v-if="maxFieldsError" class="error-message-style error-message-style-dim">
                {{ traduzione('errore.limite.campi') }}
              </span>
              <span v-if="reservedKeywordError" class="error-message-style error-message-style-dim">
                {{ traduzione('errore.parole.riservate') }}
              </span>
              <span v-if="duplicateError" class="error-message-style error-message-style-dim">
                {{ traduzione('errore.etichetta.duplicata') }}
              </span>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m12 l6 xl6">
          <form>
            <ul class="collection" v-if="items.length > 0">
              <li class="collection-item" v-for="item in items" :key="item.index">
            <div class="row d-flex align-items-center">
              <div class="col s5">
                <div v-if="editingIndex === item.index" class="input-field margin-0">
                  <input
                    type="text"
                    v-model.trim="item.name"
                    @input="clearErrors"
                    @keyup.enter="saveEdit(item)"
                    @keyup.esc="cancelEdit(item)"
                    maxlength="50"
                    class="validate"
                    auto-focus
                  />
                </div>
                <span v-else class="text-truncate"><strong>{{ item.name }}</strong></span>
              </div>

              <div class="col s2">
                <label>
                  <input type="checkbox" class="filled-in" v-model="item.showinapp" :disabled="editingIndex === item.index" />
                  <span>{{ traduzione('show.in.app') }}</span>
                </label>
              </div>

              <div class="col s3">
                <label>
                  <input type="checkbox" class="filled-in" v-model="item.is_searchable" :disabled="editingIndex === item.index" />
                  <span>{{ traduzione('checkbox.rendi.ricercabile') }}</span>
                </label>
              </div>

              <div class="col s2 right-align action-buttons">
                <div v-if="editingIndex !== item.index">
                  <i class="material-icons small blue-text pointer" title="Modifica" @click="startEdit(item)">edit</i>
                  <i v-if="isNew" class="material-icons small red-text pointer" title="Elimina" @click="removeItem(item.index)">delete</i>
                </div>

                <div v-else>
                  <i class="material-icons small green-text pointer" title="Salva" @click="saveEdit(item)">check</i>
                  <i class="material-icons small grey-text pointer" title="Annulla" @click="cancelEdit(item)">close</i>
                </div>
              </div>
            </div>

                <!-- ERRORI EDITING -->
                <!-- ERRORI EDITING -->
                <span v-if="errorsByIndex[item.index]?.duplicate && editingIndex === item.index"
                  class="error-message-style error-message-style-dim">
                  {{ traduzione('errore.etichetta.duplicata') }}
                </span>

                <span v-if="errorsByIndex[item.index]?.reserved && editingIndex === item.index"
                  class="error-message-style error-message-style-dim">
                  {{ traduzione('errore.parole.riservate') }}
                </span>

                <span v-if="errorsByIndex[item.index]?.empty && editingIndex === item.index"
                  class="error-message-style error-message-style-dim">
                  {{ traduzione('errore.etichetta.campi.pax') }}
                </span>

              </li>

            </ul>

          </form>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m12 l12">

          <a v-if="this.isNew || this.isBack"  v-red-tooltip="traduzione('btn.back')" id="goback" href="javascript:void(0)" class="btn-large btn-back" @click="goBack()">
            <i class="material-icons left arrow-back">keyboard_arrow_left</i>
          </a>

          <a id="savestructure" href="javascript:void(0)" class="btn-large " @click="saveStructure()">
            <i class="material-icons left">save</i>
            {{ this.isNew ? traduzione('bt.create.event.save.next') : traduzione('btn.save') }}

          </a>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import translationStore from '@/store/translations'
import eventSetting from '@/store/eventSettings.js'
import apiService from '@/services/apiService.js'
import loadingStore from '@/store/loading'
import toast from '@/services/toast.js'

export default {
  name: 'app',
  props: {
    isNew: { // Flag per indicare se è un nuovo guest o una modifica
      type: Boolean,
      default: false
    },
    isBack: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      // ... (altri dati)
      eventSetting: eventSetting,
      counter: 0,
      duplicateError: false,
      etichettaString: '',
      editingIndex: null,
      errorsByIndex: {},
      originalName: '',
      items: [],
      toast: toast,
      eventFiledModel: {
        event_id: null,
        fields: null
      },
      // NUOVI STATI PER I MESSAGGI DI ERRORE
      maxFieldsError: false,
      reservedKeywordError: false
    }
  },

  computed: {
    traduzione () {
      // Ho corretto qui per usare 'traduzione' come nel template
      return translationStore.getters.traduzione
    }
  },

  async mounted () {
    this.listItems()
    loadingStore.commit('setLoading', false)
  },

  methods: {

    goBack () {
      this.$router.push('/modify-event-back')
    },

    clearErrorsFor (index) {
      this.$set(this.errorsByIndex, index, {
        duplicate: false,
        reserved: false,
        empty: false
      })
    },

    startEdit (item) {
      this.clearErrorsFor(item.index)
      this.editingIndex = item.index
      this.originalName = item.name
    },

    cancelEdit (item) {
      item.name = this.originalName
      this.editingIndex = null
      this.clearErrorsFor(item.index)
    },

    saveEdit (item) {
      const idx = item.index
      this.clearErrorsFor(idx)

      const newLabel = item.name.trim()

      // vuoto
      if (!newLabel) {
        this.errorsByIndex[idx].empty = true
        return
      }

      // reserved
      if (this.isReservedKeyword(newLabel)) {
        this.errorsByIndex[idx].reserved = true
        return
      }

      // duplicato excl. se stesso
      const newLower = newLabel.toLowerCase()
      const isDuplicate = this.items.some(
        i => i.index !== idx && i.name.toLowerCase().trim() === newLower
      )
      if (isDuplicate) {
        this.errorsByIndex[idx].duplicate = true
        return
      }

      // salva
      item.name = newLabel
      this.editingIndex = null
    },

    isDuplicateLabel (label) {
      const newLabel = label.toLowerCase().trim()
      return this.items.some(item => item.name.toLowerCase().trim() === newLabel)
    },

    // Lista delle parole chiave riservate (case-insensitive)
    isReservedKeyword (label) {
      const n = this.traduzione('label.name.pax') || 'name'
      const s = this.traduzione('label.surname.pax') || 'surname'
      const e = this.traduzione('label.email.pax') || 'email'
      const nt = this.traduzione('note.field.xls') || 'notes'
      const acc = this.traduzione('accompanying.persons.number') || 'accompanying'

      const reserved = [n.toLowerCase().trim(), s.toLowerCase().trim(), e.toLowerCase().trim(), nt.toLowerCase().trim(), acc.toLowerCase().trim()]
      return reserved.includes(label.toLowerCase().trim())
    },

    listItems () {
      if (!this.isNew) {
        const structure = this.eventSetting.getters.structure || []

        this.items = structure.map((item, i) => ({
          index: i, // sempre corretto
          name: item.name,
          showinapp: item.showinapp ?? false,
          field: item.field ?? null,
          is_searchable: item.is_searchable ?? true,
          id: item.id ?? null
        }))

        // 👇 ALLINEA IL CONTATORE AL NUMERO ATTUALE DI ITEM
        this.counter = this.items.length
      }
    },

    clearErrors () {
      // Pulisce gli errori su input
      this.maxFieldsError = false
      this.reservedKeywordError = false
      this.duplicateError = false
      this.emptyError = false
      document.getElementById('error-message-campo-etichetta').classList.add('nodipslay')
      // Rimuovi la classe 'invalid' se necessario, se usi Materialize per la validazione visiva
      // const inputField = document.getElementById('etichetta');
      // if (inputField) inputField.classList.remove('invalid');
    },

    addItem () {
      loadingStore.commit('setLoading', true)
      this.clearErrors()

      const label = this.etichettaString.trim()
      const inputElement = document.getElementById('etichetta')

      if (label === '') {
        document.getElementById('error-message-campo-etichetta').classList.remove('nodipslay')
        if (inputElement) inputElement.classList.add('invalid')
        loadingStore.commit('setLoading', false)
        return
      }

      if (this.isReservedKeyword(label)) {
        this.reservedKeywordError = true
        if (inputElement) inputElement.classList.add('invalid')
        loadingStore.commit('setLoading', false)
        return
      }

      if (this.items.length >= 6) {
        this.maxFieldsError = true
        loadingStore.commit('setLoading', false)
        return
      }

      if (this.isDuplicateLabel(label)) {
        this.duplicateError = true
        if (inputElement) inputElement.classList.add('invalid')
        loadingStore.commit('setLoading', false)
        return
      }

      // 👇 CREA ITEM CON INDEX CORRETTO
      this.items.push({
        index: this.items.length,
        name: label,
        showinapp: false,
        is_searchable: true,
        id: null
      })

      this.etichettaString = ''
      if (inputElement) inputElement.classList.remove('invalid')

      loadingStore.commit('setLoading', false)
    },

    removeItem (index) {
      const posizioneNellArray = this.items.findIndex(item => item.index === index)

      // Se l'elemento è stato trovato, rimuovilo
      if (posizioneNellArray !== -1) {
        this.items.splice(posizioneNellArray, 1)
        // Rimuovi qualsiasi messaggio di errore sul limite massimo se la lista torna sotto 6
        if (this.items.length < 6) {
          this.maxFieldsError = false
        }
      }
    },

    async saveStructure () {
      loadingStore.commit('setLoading', true)
      let i = 0
      this.eventFiledModel.event_id = this.eventSetting.getters.uidEvent
      for (const item of this.items) {
        item.field = 'field' + i
        i++
      }

      this.eventFiledModel.fields = this.items
      const url = process.env.VUE_APP_URL_EVENTS + '/eventlabels/savelabels'
      const token = await apiService.getClientCredentialsToken()

      const jsonCntry = await apiService.sendRequestWithBearer('POST', url, token, this.eventFiledModel)

      if (jsonCntry.error) {
        // ... (gestione errore)
        document.getElementById('etichetta').classList.add('invalid') // Usa 'etichetta' ID
        loadingStore.commit('setLoading', false)
        return
      }
      eventSetting.dispatch('setStructureEventPax', jsonCntry)

      if (this.isNew || this.isBack) {
        this.$router.push('/new-event-step3')
      } else {
        this.$router.push('/list-guests')
      }

      const msg = 'Etichette salvate correttamente'

      loadingStore.commit('setLoading', false)
      this.toast.createStampToast('thumb_up', msg, 'toast-green')
    }
  },

  created () {
    loadingStore.commit('setLoading', false)
  }
}
</script>

<style>
/* ... (Stili invariati) ... */
h1.style {
  color: black !important;
  font-size: 1.5em;
}

.marigne-lat {
  padding-left: 5%;
  padding-right: 5%;
}

.onmouseover {
  cursor: pointer;
}

/* Nuovo stile per il messaggio di errore sul limite */
.error-message-style-dim {

  font-size: 16px !important;
}

.nodipslay {
  display: none !important;
}
</style>
